<template>
    <div id="app-attachment">
    <v-card-title 
        class="ml-n4"
    >
        <v-btn 
        @click	="Add"
        class	="ml-4 mr-2"
        title	="Add New"
        small
        outlined
        :disabled="dialog_modul === 'cbcprofile'?true:false"
        >{{$vars.V('txt_add')}}
        </v-btn>
        <v-btn 
        color="secondary"
        @click="List(dialog_refno, dialog_join, modulselect)"
        class="mr-2"
        title="Refresh"
        small
        outlined
        ><v-icon>{{$vars.V('icon_refresh')}}</v-icon>
        </v-btn>
        <v-btn 
        color  = "primary"
        title  = "search"
        v-if   = "btn_search === false"
        @click = "btn_search = true"
        outlined
        small>
        <v-icon>{{$vars.V('icon_search')}}</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        @click:append="btn_search = false"
        label="Search"
        single-line
        hide-details
        v-if ="btn_search"
        ></v-text-field>
    </v-card-title>
        <template>
        <v-card
            class="mx-auto"
            flat
        >
            <template
             v-if="dialog_modul === 'cbcprofile'">
            <v-btn
              v-for="item in detail.attachmentmodulall"
              :key="item.code_id"
              :value="item.code_id"
              :outlined="modulselect === item.code_id?false:true"
              small
              depressed
              color="fourth"
              class="mx-1"
              @click="ChangeModul(item.code_id)"
            >
              {{ item.code_desc }}
            </v-btn>
            </template>
             <v-progress-linear
              indeterminate
              color="fourth"
              depressed
              v-if="loading.detail"
              ></v-progress-linear>
              <v-sheet
                  class="pa-2"
                  elevation="1"
                  rounded
                  style="max-height: 300px; overflow-y: auto;"
                  @scroll.passive="OnScroll"
                  ref="scrollContainer"
                >
                <v-list dense>
                  <div
                    v-for="(folder, index) in filterattachment"
                    :key="folder.attachment_id"
                  >
                    <v-list-item class="py-1">
                      <v-list-item-avatar size="36">
                        <v-icon size="24">
                          {{ $functions.AttachmentIcon(folder.attachment_ext) }}
                        </v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="text-truncate" :title="folder.attachment_path">
                          {{ folder.attachment_path }}
                        </v-list-item-title>

                        <v-list-item-subtitle class="text-caption grey--text">
                          <v-icon small class="mr-1">mdi-account-outline</v-icon>
                          {{ folder.attachment_cuser }} -
                          {{ folder.attachment_title }} -
                          {{ $functions.FormatDateTime(folder.attachment_cdate) }}
                        </v-list-item-subtitle>

                         <v-list-item-subtitle class="text-truncate">
                          <v-icon small class="mr-1">mdi-view-module</v-icon>
                          {{ folder.attachment_modul}}
                        </v-list-item-subtitle>

                        <v-list-item-subtitle class="text-caption grey--text">
                          <v-icon small class="mr-1">mdi-database</v-icon>
                          {{ parseFloat(folder.attachment_size).toFixed(2) }} MB
                        </v-list-item-subtitle>

                        <v-list-item-subtitle class="mt-1">
                          <template v-if="folder.attachment_type">
                            <v-icon small class="mr-1">mdi-file-cabinet</v-icon>
                            {{ folder.attachment_type }} - {{ folder.attachment_type_desc }}
                            <!-- <v-icon small class="ml-2 red--text" @click="UpdateAttachType('delete', folder)">
                              mdi-close-circle
                            </v-icon> -->
                          </template>
                          <template v-else>
                            <v-autocomplete
                              v-model="folder.attachment_type"
                              :items="detail.attachmenttype"
                              dense
                              hide-details
                              outlined
                              item-value="code_id"
                              :item-text="item => `${item.code_id} - ${item.code_desc}`"
                              return-object
                              :filter="CustomFilter"
                              @change="UpdateAttachType('edit', folder)"
                              clearable
                            />
                          </template>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn icon @click="$functions.OpenUrl(folder.attachment_path_url)">
                          <v-icon>mdi-download-circle</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <!-- Divider antar item, kecuali setelah item terakhir -->
                    <v-divider v-if="index < filterattachment.length - 1" class="my-1" />
                  </div>
                </v-list>
                <v-progress-linear
                    v-if="loading.more"
                    indeterminate
                    color="primary"
                    class="mt-2"
                  />
              </v-sheet>       
        </v-card>
        </template>
    <!-- Start Form -->
    <v-dialog
      v-model="dialog.detail"
      max-width="800"
      transition="dialog-transition"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary" dense class="mb-2">
          <v-btn icon dark @click="dialog.detail = false">
            <v-icon>{{$vars.V('icon_close')}}</v-icon>
          </v-btn>
          <v-toolbar-title>Attachment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Add" title="Add New"><v-icon color="white">add</v-icon></v-btn>
          <v-btn icon dark @click="Confirm(url_type, '')" title="Save"><v-icon color="white">save</v-icon></v-btn>
        </v-toolbar>
      <v-card-text>
      <v-form enctype="multipart/form-data" ref="form_attachment" lazy-validation>
        <v-row class="mx-auto">
            <v-col cols="12" sm="4" md="4" class="mt-4" v-if="dialog_modul === 'cbcprofile'">
                <v-autocomplete
                  v-model="form.attachment_modul"
                  :items="detail.attachmentmodul"
                  label="Module"
                  dense
                  outlined
                  return-object
                  item-value="code_id"
                  :item-text="item => `${item.code_desc}`"
                  clearable
                  :filter="CustomFilter"
                />
            </v-col>
            <v-col cols="12" :sm="dialog_modul === 'cbcprofile'?'4':'8'" :md="dialog_modul === 'cbcprofile'?'4':'8'">
              <v-text-field 
              v-model       ="form.attachment_title"
              required 
              label       	="Document No"
              placeholder 	="Document No"
              id 		        ="attachment_title"
              :rules 	  	  ="form.attachment_title_rules"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="mt-4">
                <v-autocomplete
                  v-model="form.attachment_type"
                  :items="detail.attachmenttype"
                  label="Type"
                  dense
                  outlined
                  return-object
                  item-value="code_id"
                  :item-text="item => `${item.code_id} - ${item.code_desc}`"
                  :filter="CustomFilter"
                  :readonly="dialog_flag === 'Y'?true:false"
                />
            </v-col>
              <v-col cols="12" sm="12" md="12" class="mt-n6">
              <v-text-field 
              v-model       ="form.attachment_remarks"
              required 
              label       	="Remarks"
              placeholder 	="Remarks"
              id 		        ="attachment_remarks"
              :rules 	      ="form.attachment_remarks_rules"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="10" md="10">
              <v-card  flat class="secondary text-center cursor" width="500" height="150" @click="UploadPath" :img="form.attachment_path_url">
                <div class="caption primary mb-3 white--text">Attachment</div>
                <div>{{form.attachment_path_name}}</div>
                <input
                  type="file"
                  ref="attachment_path"
                  @change="UploadPathURL"
                  accept=".jpg, .jpeg, .png, .pdf"
                  style="display: none"
                />
              </v-card>
            </v-col>
            <!-- Active -->
            <v-col cols="12" sm="2" md="2" class="mt-n5">
              <label class="caption">Active Status</label>
              <v-switch
                v-model="form.attachment_actived"
                color="primary"
                id="form.attachment_actived"
                :label="form.attachment_actived !== true ? '' : 'Active'"
              ></v-switch>
            </v-col>
        </v-row>
      </v-form>
      </v-card-text>
      <v-card-actions>
        
      </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model	  ="snackbar.dialog"
      :timeout  ="snackbar.timeout"
      color		  ="fourth"
      rounded	  ="pill"
      top
      absolute
    >
      {{ snackbar.text }}
      <template>
        <v-btn dark text @click.native="remarks.dialog = true" small v-if="snackbar.color === 'error'">Open</v-btn>
        <v-btn dark text @click.native="snackbar.dialog = false" small>Close</v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="confirm.dialog" :max-width="Variable('confirm',0)" persistent>
      <v-card :color="Variable('confirm',4)">
        <v-card-title :class="Variable('confirm',3)">{{confirm.title}}?</v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            id="dialog"
            :color="Variable('confirm',1)"
            :disabled   ="confirm.text === 'Ok' ? false:true"
            @click      ="Loading"
          >
            {{confirm.text}}
          </v-btn>
          <v-btn :color="Variable('confirm',2)" @click="confirm.dialog=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="remarks.dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent max-width="290" v-if="remarks.feedback !== ''">
      <v-card>
        <v-toolbar dark color="fourth" dense>
          <v-btn icon dark @click="remarks.dialog = false">
            <v-icon>{{$vars.V('icon_close')}}</v-icon>
          </v-btn>
          <v-toolbar-title>Error Messages</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-2 ml-n2">
          <div class="subheading font-weight-bold" v-html="remarks.feedback"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Organization -->
    </div>
</template>
<script>
export default {
  props: {
    dialog_modul: String,
    dialog_refno: String,
    dialog_join: String,
    dialog_flag: String,
  },
  data: () => ({
    url_type: 'add',
    modulselect: 'cbcprofile',
    page: 1,
    limit: 10,
    hasMore: true,
    access: {
      read    : 0,
      add     : 0,
      edit    : 0,
      delete  : 0,
    },
    remarks: {
        feedback: "",
        dialog: false,
    },
    snackbar: {
        dialog: false,
        color: "success",
        text: "",
        timeout: 3000,
    },
    confirm: {
        dialog: false,
        title: "",
        text: "Ok",
    },
    loading: {
        page      : true,
        detail    : true,
        more    : false,
    },
    dialog: {
        detail: false
    },
    formatamount: {
      locale: "id-ID",
      prefix: "",
      suffix: "",
      length: 15,
      precision: 0
    },
    formatrate: {
      locale: "id-ID",
      prefix: "",
      suffix: "",
      length: 5,
      precision: 2
    },
    properties: {
      reverse: true
    },
    selected: [],
    items: [],
    btn_search: false,
    search: '',
    headers: [
      { text: 'ID', value: 'attachment_id' },
      { text: 'Type', value: 'attachment_type_desc' },
      { text: 'Docno', value: 'attachment_title' },
      { text: 'Ext', value: 'attachment_ext' },
      { text: 'Path', value: 'attachment_path' },
      { text: 'Remarks', value: 'attachment_remarks' },
      { text: 'Size', value: 'attachment_size' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    form: {
        attachment_id: '',
        attachment_modul: '',
        attachment_refno: '',
        attachment_title: '',
        attachment_title_rules: [(v) => !!v || "Please fill Document No"],
        attachment_remarks: '',
        attachment_remarks_rules: [(v) => !!v || "Please fill Remarks"],
        attachment_ext: '',
        attachment_path: '',
        attachment_path_url: '',
        attachment_path_name: '',
        attachment_type: '',
        attachment_typedesc: '',
        attachment_cuser: '',
        attachment_cdate: '',
        attachment_luser: '',
        attachment_ldate: '',
        attachment_actived: true,
    },
    detail: {
      attachmenttype: [],
      attachmentmodul: [
            {"code_id":"profile","code_desc":"Profile"},
            {"code_id":"cbc","code_desc":"Case By Case"},
          ],
      attachmentmodulall: [
            {"code_id":"cbcprofile","code_desc":"All"},
            {"code_id":"profile","code_desc":"Profile"},
            {"code_id":"cbc","code_desc":"Case By Case"},
          ],
    }
   }),
   created() {
    if (this.dialog_refno !== '' && this.dialog_modul !== '') {
      this.List(this.dialog_refno, this.dialog_join, this.dialog_modul)
    }
   },
   watch: {
    dialog_refno: function (newdata) {
      if (newdata !== "") {
        this.List(newdata, this.dialog_join, this.dialog_modul)
      }
    },
  },
   computed: {
      // Filter Brands
      filterattachment() {
        const search = this.search.toLowerCase().trim();
        if (!search) {
          return this.items;
        } else {
          return this.items.filter(b => {
            const typeDesc = b.attachment_typedesc?.toLowerCase() || "";
            const title = b.attachment_title?.toLowerCase() || "";
            return typeDesc.includes(search) || title.includes(search);
          });
        }
      },
   },
   methods: {
    Access() {
        let modul = 'attachment'
        let formdata = {
            menu_id     : modul,
            users_id    : this.$functions.UsersID(),
            order_by    : 'menu_id',
            order_type  : 'ASC',
            limit       : String(this.limit),
        }
        let param = this.$functions.ParamPOST(formdata)
        this.$axios
        .post(this.$functions.UrlPOST('apiListMenuUser'), param, {
            headers: {
            'Content-Type': 'text/plain charset=ISO-8859-1',
            },
        })
        .then((response) => {
            let priv = response.data
            if (priv.length > 0) {
            this.access.read = priv[0].usersmenu_read
            this.access.add = priv[0].usersmenu_add
            this.access.edit = priv[0].usersmenu_edit
            this.access.delete = priv[0].usersmenu_delete
            if (priv[0].usersmenu_read === 0) {
                this.SnackBar(true, 'error', this.$functions.NoPriviledge(modul), 3000)
            }
            } else {
            this.SnackBar(true, 'error', this.$functions.NoPriviledge(modul), 3000)
            }
            this.loading.page = false
        })
        .catch((e) => {
            this.SnackBar(true, 'error', e, 3000)
            this.loading.page = false
        })
    },
    SnackBar(dialog, color, text, timeout) {
        this.snackbar = {
            dialog: dialog,
            color: color,
            text: text,
            timeout: timeout,
        }
        if (color === "error") {
            this.confirm.dialog 	= false
            this.confirm.text 		= "Ok"
        }
    },
    Variable (flag, position) {
        return this.$functions.Variable(flag,position)
    },
    SelectAllPage () {
        this.selected = this.selected === this.items ? [] : this.items
    },
    Check (value) {
        this.selected = value
    },
    Loading () {
        this.confirm.text = 'Loading...'
        if (this.url_type === 'add' || this.url_type === 'edit') {
            this.Write()
        } else if (this.url_type === 'delete') {
            this.Delete(this.form.attachment_id)
        } else if (this.url_type === 'multidelete') {
            this.MultiProcess('delete')
        }
    },
    Write () {
      let modul = this.dialog_modul
      let refno = this.dialog_refno
      if (this.form.attachment_modul !== '') {
        modul = this.form.attachment_modul
        if (this.form.attachment_modul === 'profile') {
          refno = this.dialog_join
        }
      } else {
        if (this.dialog_modul === 'cbcprofile') {
          modul = 'cbc'
        }
      }
      let formdata = {
        url_type: this.url_type,
        attachment_refno: refno,
        attachment_join: this.dialog_join,
        attachment_modul: modul,
        attachment_title: this.form.attachment_title,
        attachment_type: this.form.attachment_type.code_id,
        attachment_remarks: this.form.attachment_remarks,
        attachment_path: this.form.attachment_path,
        attachment_path_url: this.form.attachment_path_url,
        attachment_actived: this.$functions.ActivedFlag(this.form.attachment_actived),
      }
      let param 	   = this.$functions.ParamPOST(formdata)
      this.$axios.post(this.$functions.UrlPOST('apiWriteAttachment'),param,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data
        if (feedback.length > 0) {
          if (feedback[0].feedback === 'Y') {
            this.SnackBar(true, 'success', 'Save Success', 3000)
            this.dialog.detail = false
            this.confirm.dialog  	 = false
            this.confirm.text 	 	 = 'Ok'
            if (this.url_type === 'add') {
              this.form.attachment_cuser  = feedback[0].feedback_users_id
              this.form.attachment_cdate  = feedback[0].feedback_users_date
            }
            this.List(this.dialog_refno)
            this.form.attachment_luser  = feedback[0].feedback_users_id
            this.form.attachment_ldate  = feedback[0].feedback_users_date
            this.url_type 		      = 'edit'
          } else {
            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
            this.remarks.dialog = true
            this.remarks.feedback = feedback[0].feedback
            this.confirm.dialog  	 = false
            this.confirm.text 	 	 = 'Ok'
            
          }
        } else {
          this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
          this.remarks.dialog = true
          this.remarks.feedback = feedback
        }
      })
      .catch(e => {
        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
        this.remarks.dialog = true
        this.remarks.feedback = e
      })
    },
    Delete (id) {
      let formdata = {
        url_type: 'delete',
        attachment_id: id
      }
      let param 	   = this.$functions.ParamPOST(formdata)
      this.$axios.post(this.$functions.UrlPOST('apiWriteAttachment'),param,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data
        if (feedback.length > 0) {
          if (feedback[0].feedback === 'Y') {
            this.SnackBar(true, 'success', 'Delete Success', 3000)
            this.confirm.dialog  	= false
            this.confirm.text 		= 'Ok'
            this.List(this.dialog_refno)
          } else {
            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
            this.remarks.dialog = true
            this.remarks.feedback = feedback[0].feedback
            this.confirm.dialog  	= false
            this.confirm.text 		= 'Ok'
          }
        }
      })
      .catch(e => {
        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
        this.remarks.dialog = true
        this.remarks.feedback = e
        this.confirm.dialog  	= false
        this.confirm.text 		= 'Ok'
      })
    },
    Add() { 
      this.dialog.detail = true
      this.url_type = 'add'
      this.form.attachment_title = ''
      this.form.attachment_remarks = ''
      if (this.dialog_flag === 'Y') {
        let lengths = this.items.length + 1
        this.form.attachment_title = this.dialog_refno +'-D44-'+lengths
        this.form.attachment_remarks = 'LAMPIRAN LAINNYA'
        this.form.attachment_type = 'D44'
      }
      setTimeout(function () {
        document.getElementById("attachment_title").focus();
      }, 500)
    },
    Edit (id) {
      if (id !== '') {
        this.Add()
        this.loading.detail = true
        let formdata = {
          attachment_id: id
        }
        let param 	   = this.$functions.ParamPOST(formdata)
        this.$axios.post(this.$functions.UrlPOST('apiListAttachment'),param,{
          headers: {
            'Content-Type': 'text/plain; charset=ISO-8859-1'
          }
        })
        .then(response => {
          let feedback = response.data
          if (feedback.length > 0) {
            if (feedback[0].feedback === 'Y') {
                this.dialog.detail = true
                this.url_type = 'edit'
                this.form.attachment_modul = feedback[0].attachment_modul
                this.form.attachment_refno = feedback[0].attachment_refno
                this.form.attachment_ext = feedback[0].attachment_ext
                this.form.attachment_type = feedback[0].attachment_type
                this.form.attachment_typedesc = feedback[0].attachment_typedesc
                this.form.attachment_title = feedback[0].attachment_title
                this.form.attachment_remarks = feedback[0].attachment_remarks
                this.form.attachment_path = feedback[0].attachment_path
                this.form.attachment_path_url = feedback[0].attachment_path_url
                this.form.attachment_actived = this.$functions.TrueOrFalse(feedback[0].attachment_actived)
            } else {
                this.SnackBar(true, 'error', feedback[0].feedback, '3000')
            }
          } else {
            this.SnackBar(true, 'error', this.$functions.NoData(), '3000')
          }
          this.loading.detail = false
        })
        .catch(e => {
          this.SnackBar(true, 'error', e, 3000)
          this.loading.detail = false
        })
      }
    },
    Confirm (flag, id) {
      if (flag === 'add' || flag === 'edit') {
        if (this.$refs.form_attachment.validate()) {
          this.confirm.dialog   	= true
          this.confirm.title    	= 'Save'
          this.url_type 			    = 'add'
          setTimeout(function(){
          document.getElementById('dialog').focus()
          }, 500)
        }
      } else if (flag === 'delete') {
        this.url_type	  = 'delete'
        this.confirm.dialog       = true
        this.confirm.title        = 'Delete `'+ id + '`'
        this.form.attachment_id 	        = id
        setTimeout(function(){
        document.getElementById('dialog').focus()
        }, 500)
      } else if (flag === 'multidelete') {
        this.url_type 		        = 'multidelete'
        this.confirm.dialog   = true
        this.confirm.title    = 'Delete `'+ this.selected.length + '` data'
        setTimeout(function(){
        document.getElementById('dialog').focus()
        }, 500)
      }
    },
    OnScroll(e) {
      const container = e.target;
      if (
        container.scrollTop + container.clientHeight >= container.scrollHeight - 10 &&
        !this.loading.more &&
        this.hasMore
      ) {
        this.LoadMore();
      }
    },

    async LoadMore() {
      this.loading.more = true;
      this.page++;

      let formdata = {
        attachment_refno: this.dialog_refno,
        attachment_join: this.dialog_join,
        attachment_modul: this.modulselect,
        order_by: 'attachment_id',
        order_type: 'ASC',
        limit: String(this.limit),
        offset: String((this.page - 1) * this.limit)
      };
      let param = this.$functions.ParamPOST(formdata);

      try {
        const response = await this.$axios.post(
          this.$functions.UrlPOST('apiListAttachment'),
          param,
          { headers: { 'Content-Type': 'text/plain; charset=ISO-8859-1' } }
        );
        let feedback = response.data;

        if (feedback.length > 0 && feedback[0].feedback === "Y") {
          if (feedback.length < this.limit) {
            this.hasMore = false;
          }
          this.items.push(...feedback);
        } else {
          this.hasMore = false;
        }
      } catch (e) {
        this.SnackBar(true, "error", e, 3000);
        this.hasMore = false;
      } finally {
        this.loading.more = false;
      }
    },
    List (refno, join, modul) {
      this.Access()
      this.AttachmentType()
      this.items = []
      if (this.dialog_refno !== '') {
        this.loading.detail = true
        let formdata = {
          attachment_refno: refno,
          attachment_join: join,
          attachment_modul: modul,
          order_by: 'attachment_id',
          order_type: 'ASC',
          limit: String(this.limit),
          offset: String(0)
        }
        let param 	   = this.$functions.ParamPOST(formdata)
        this.$axios.post(this.$functions.UrlPOST('apiListAttachment'),param,{
          headers: {
            'Content-Type': 'text/plain; charset=ISO-8859-1'
          }
        })
        .then(response => {
          let feedback = response.data
          if (feedback.length > 0) {
            if (feedback[0].feedback !== 'Y') {
              this.SnackBar(true, 'error', feedback[0].feedback, 3000)
            } else {
              this.items = feedback
            }
          } else {
            this.items = feedback
            // this.SnackBar(true, 'error', this.$functions.NoData(), 3000)
          }
          this.loading.detail = false
        })
        .catch(e => {
          this.SnackBar(true, 'error', e, 3000)
          this.loading.detail = false
        })
      }
    },
    UploadPath() {
      this.$refs.attachment_path.click();
    },
    UploadPathURL() {
      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.attachment_path_url = e.target.result;
          this.form.attachment_path = e.target.result;
        };
        this.form.attachment_path_name = input.files[0].name;
        reader.readAsDataURL(input.files[0]);
      }
    },
    AttachmentType () {
      let formdata = {
        code_group: 'DOCUMENT',
        code_actived: 'Y',
        order_by: 'code_id',
        order_type: 'ASC'
      }
      let param 	   = this.$functions.ParamPOST(formdata)
      this.$axios.post(this.$functions.UrlPOST('apiListCode'),param,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data
        if (feedback.length > 0) {
          if (feedback[0].feedback === 'Y') {
            this.detail.attachmenttype =  feedback
          } else {
            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
            this.remarks.dialog   = true
            this.remarks.feedback = feedback[0].feedback
          }
        }
      })
      .catch(e => {
        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
        this.remarks.dialog   = true
        this.remarks.feedback = e
      })
    },
    UpdateAttachType (flag,item){
      let type = item.attachment_type.code_id
      if (flag === 'delete') {
        type = ''
      }
      this.loading.attachment = true
      let formdata = {
        url_type: 'edittype',
        attachment_id: item.attachment_id,
        attachment_type: type
      }
      let param 	   = this.$functions.ParamPOST(formdata)
      this.$axios.post(this.$functions.UrlPOST('apiWriteAttachment'),param,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data
        if (feedback.length > 0) {
          if (feedback[0].feedback === 'Y') {
            this.List(this.dialog_refno, this.dialog_join, this.modulselect)
          } else {
            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
            this.remarks.dialog   = true
            this.remarks.feedback = feedback[0].feedback
          }
          this.loading.attachment = false
        }
      })
      .catch(e => {
        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
        this.remarks.dialog   = true
        this.remarks.feedback = e
        this.loading.attachment = false
      })
    },
    CustomFilter(item, queryText) {
        const text = `${item.code_id} ${item.code_desc}`.toLowerCase();
        const search = queryText.toLowerCase();
        return text.includes(search);
      },
    ChangeModul(val) {
        this.modulselect = val
        // reset data list sesuai modul baru
        this.List(this.dialog_refno, this.dialog_join, val)
    },
    },
}
</script>